import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../shared/cart.service';
import { CartItem } from '../../models/cart-item.model';

@Component({
  selector: 'my-app-cart',
  templateUrl: './my-cart.component.html',
  styleUrls: ['./my-cart.component.scss']
})
export class MyCartComponent implements OnInit {
  cartItems: CartItem[] = [];
  maxQuantity: number = 6;
  totalPrice: number = 0;
  isMobile: boolean = false;

  constructor(private cartService: CartService, private router: Router) {}

  ngOnInit() {
    this.cartItems = this.cartService.getItems();
    this.calculateTotal();
    this.checkScreenSize();
  }

  calculateTotal() {
    this.totalPrice = this.cartService.getTotal();
  }

  increaseQuantity(item: CartItem) {
    if (item.quantity < this.maxQuantity) {
      this.cartService.increaseQuantity(item);
      this.calculateTotal();
    }
  }

  decreaseQuantity(item: CartItem) {
    if (item.quantity > 1) {
      this.cartService.decreaseQuantity(item);
      this.calculateTotal();
    }
  }

  onQuantityChange(item: CartItem) {
    if (item.quantity > 0 && item.quantity <= this.maxQuantity) {
      this.cartService.updateItem(item);
      this.calculateTotal();
    }
  }

  removeItem(item: CartItem) {
    this.cartItems = this.cartItems.filter(cartItem => cartItem.product.id !== item.product.id || (item.option && cartItem.option?.id !== item.option.id));
    this.cartService.removeItem(item);
    this.calculateTotal();
  }

  proceedToCheckout() {
    this.router.navigate(['/checkout']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }
}
